import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useState, useContext, useEffect } from 'react';
import i18next from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { normalizeSlug } from '../../../helpers/admin';
import useWidgetStore from '../store/useWidgetStore';
const initialState = {
    supportedLanguages: ['nl', 'en', 'fr', 'de'],
    allowSwitch: false,
    showKeys: false,
    defaultLanguage: 'nl',
    translations: {
        nl: {},
        en: {},
        fr: {},
        de: {}
    },
    t: (key, group) => key,
    ts: (key, params, group) => key
};
export const I18NContext = createContext(initialState);
export const useI18N = () => {
    return useContext(I18NContext);
};
let lng = 'nl'; // is later set correctly by an effect
i18next.use(initReactI18next).init({
    lng: lng,
    debug: false, //process.env.NODE_ENV !== 'production','
    resources: initialState.translations
}, () => { }).then(r => {
});
const I18NProvider = ({ children, initial }) => {
    const [i18n, setI18N] = useState(Object.assign(Object.assign({}, initialState), initial));
    const { language, setLanguage } = useWidgetStore();
    useEffect(() => {
        let userLanguage = localStorage.getItem('oaLanguage');
        if (userLanguage) {
            if (i18n.supportedLanguages.includes(userLanguage)) {
                setLanguage(userLanguage);
                return;
            }
            else {
                setLanguage(i18n.defaultLanguage);
            }
        }
        if (i18n.supportedLanguages.includes(i18n.defaultLanguage)) {
            setLanguage(i18n.defaultLanguage);
        }
    }, []);
    useEffect(() => {
        if (i18n.translations[language]) {
            i18next.addResourceBundle(language, 'translation', i18n.translations[language]);
            i18next.changeLanguage(language);
        }
    }, [language]);
    const { t } = useTranslation();
    i18n.t = (key, group) => {
        let slug = normalizeSlug(key).substring(0, 24), path = group !== null && group !== void 0 ? group : location.hash.substring(12);
        if (path.includes('/'))
            path = path.substring(0, path.indexOf('/'));
        let textkey = `${path}.${slug}`, translated = t(textkey);
        if (i18n.showKeys) {
            let yiiKey = `widget2k25_${path}__${slug}`;
            console.log(`${textkey} ( Yii: ${yiiKey} )`);
        }
        return i18n.showKeys ? textkey : (translated !== textkey && translated !== '~' ? translated : key);
    };
    i18n.ts = (key, params, group) => {
        let _translated = i18n.t(key, group);
        for (const [_key, _value] of Object.entries(params)) {
            _translated = _translated.replaceAll(`%${_key}%`, _value.toString());
            let _search = `\%${_key}=(.+)\\?([^\%]+):([^\%]+)\%`;
            Array.from(_translated.matchAll(new RegExp(_search, 'g'))).forEach((match, index) => {
                _translated = _translated.replaceAll(match[0], match[1] === _value.toString() ? match[2] : match[3]);
            });
        }
        return _translated;
    };
    return (_jsx(I18NContext.Provider, { value: i18n, children: children }));
};
export default I18NProvider;
